module.exports = __webpack_public_path__ + "static/media/recent-user-2.657fa567.png";